import React from 'react'
import moment from 'moment'
import _ from "lodash";

import {
  SellsStep,
  RiskStep,
  DocumentsDownload
} from '../StepContent/components/step/FinalizeSteps'
import {
  radioYesUID,
  radioNoUID,
  FIELD_REQUIRED_MSG,
  FIELD_DOES_NOT_FITT_MSG,
  CONGRATS_STEP_ID,
  QUESTION_TYPE,
  newDesignInputCustomClasses,
  INTERVIEW_TYPE_CONTINUE_OPTION_VALUE,
} from '../../constants'
import {isRequiredQuestion, validateMultilineContent} from '../../utils'
import {buildQuestionUIDForMember} from "../../service";
import DateAndPlaceStep
  from "../StepContent/components/step/FinalizeSteps/ConversationDetailsStep/SubSteps/DateAndPlaceStep";
import ParticipantsStep
  from "../StepContent/components/step/FinalizeSteps/ConversationDetailsStep/SubSteps/ParticipantsStep";
import WaysOfDistributionStep from "../StepContent/components/step/FinalizeSteps/WaysOfDistributionStep";
import ClientStepV2 from "../StepContent/components/step/FinalizeSteps/ClientStepV2";
import {GREY_INFO_COLOR} from "../../../../themes/themeConfigurator";
import {RISK_STEP_LABEL} from "../StepContent/components/step/FinalizeSteps/RiskStep/RiskStep";
import {initDocumentsStep} from "../StepContent/components/step/FinalizeSteps/DocumentsDownload/utils";


const finilizeSellsStep = {
  "uid": "finalize-sells",
  "name": "Bitte auswählen",
  "behaviour": ["dynamic"],
  "category": "Verkaufsunterlagen",
  "step_content": SellsStep,
  "question": [
    {
      "uid": "main_information_provided['checkbox']",
      "type": QUESTION_TYPE.CHECKBOX_CARD,
      "answer": true,
      "question_text": "Aktuelle Produktinformationen wurden zur Verfügung gestellt.",  // Current product information has been made available to the customer.
      "optional": true,
      "required_check": true,
    },
    {
      "uid": "yearly_report_information_provided['checkbox']",
      "type": QUESTION_TYPE.CHECKBOX_CARD,
      "question_text": "Der Verkaufsprospekt sowie der letzte veröffentlichte Jahres- und Halbjahresbericht wurden kostenlos zur Verfügung gestellt.",
      "info": "Das Zurverfügungstellen dieser Dokumente ist verpflichtend, wenn Alternative Investmentfonds zum Erwerb empfohlen wurden.",
      "optional": true,
    }
  ],
};

const conflictsStep = {
  "uid": "finalize-sells-conflicts",
  "name": "Der Kunde/die Kundin wurde auf eventuelle Interessenkonflikte hingewiesen bzw. wurden entsprechende Hinweise ausgehändigt. *",
  "behaviour": ["dynamic"],
  "category": "Interessenkonflikte",
  "step_content": SellsStep,
  "question": [
    {
      "uid": "conflicts",
      "question_text": "",
      "info_text": "Sind Sie sich sicher, dass Sie nicht auf Interessenkonflikte hingewiesen haben? Dies kann zu Beanstandungen bei einer Prüfung durch den Wirtschaftsprüfer führen. Es wird empfohlen, die Offenlegung der Interessenkonflikte bei allen Kunden vorzunehmen und dies in jeder Beratung zu dokumentieren. Die Offenlegung kann mittels Übergabe der Kundenerstinformation erfolgen.",
      "type": "normal",
      "behaviour": [QUESTION_TYPE.RADIO_CARDS],
      "config": {
        "choices": [
          {
            "id": 1,
            "uid": radioYesUID,
            "text": "Ja"
          },
          {
            "id": 2,
            "uid": radioNoUID,
            "text": "Nein"
          }
        ]
      },
      "optional": true,
      "required_check": true,
      "size": 8,
    },
    {
      "uid": "conflicts_details",
      "question_text": "Angaben zu Interessenkonflikten oder zusätzliche Bemerkungen",
      "type": "input",
      "optional": true,
      "custom_classes": {"labelRoot": "bold"},
      "config": {
        "placeholder": "Mehr über die Interessekonflikte oder zusätzliche Bemerkungen"
      },
      "validateImmediately": true,
      "isValid": function(step=undefined) {
        if (step) {
          if (this.answer) {
            let isValid = validateMultilineContent(this.answer, 770)
            this.error = isValid ? null : FIELD_DOES_NOT_FITT_MSG
            return isValid
          }
        }
        this.error = null
        return true
      }
    }
  ]
};

// TODO: for missing fields summary every question shown so using same name as workaround
const step2 = {
  "uid": "finalize-risk",
  "name": 'Aufklärung über Risiken',
  "behaviour": ["dynamic"],
  "category": "Risiken",
  "step_content": RiskStep,
  "question": [
    {
      "uid": "risk",
      "type": QUESTION_TYPE.CHECKBOX_CARD,
      "question_text": "Der Kunde/die Kundin wurde über die mit der Investitionsentscheidung in Verbindung stehenden " +
        "Risiken aufgeklärt. Insbesondere wurde der Kunde/die Kundin darauf hingewiesen, dass das Risiko eines " +
        "Totalverlustes der investierten Vermögenswerte besteht.",
      "optional": true,
      "required_check": true,
      "custom_classes": {"label": "regular"}
    },
    {
      "uid": "risk_credit",
      "type": QUESTION_TYPE.CHECKBOX_CARD,
      "name": RISK_STEP_LABEL,
      "question_text": "Bonitätsrisiko",
      "custom_classes": {"label": "regular"},
      "size": 6,
    },
    {
      "uid": "risk_emittent",
      "type": QUESTION_TYPE.CHECKBOX_CARD,
      "question_text": "Emittentenrisiko",
      "name": RISK_STEP_LABEL,
      "custom_classes": {"label": "regular"},
      "size": 6,
    },
    {
      "uid": "risk_termination",
      "type": QUESTION_TYPE.CHECKBOX_CARD,
      "name": RISK_STEP_LABEL,
      "question_text": "Kündigungsrisiko",
      "custom_classes": {"label": "regular"},
      "size": 6,
    },
    {
      "uid": "risk_economic",
      "type": QUESTION_TYPE.CHECKBOX_CARD,
      "name": RISK_STEP_LABEL,
      "question_text": "Konjunkturrisiko",
      "custom_classes": {"label": "regular"},
      "size": 6,
    },
    {
      "uid": "risk_exchange_rate",
      "type": QUESTION_TYPE.CHECKBOX_CARD,
      "name": RISK_STEP_LABEL,
      "question_text": "Kursänderungsrisiko",
      "custom_classes": {"label": "regular"},
      "size": 6,
    },
    {
      "uid": "risk_liquidity",
      "type": QUESTION_TYPE.CHECKBOX_CARD,
      "name": RISK_STEP_LABEL,
      "question_text": "Liquiditätsrisiko",
      "custom_classes": {"label": "regular"},
      "size": 6,
    },
    {
      "uid": "risk_suspension_redemption",
      "type": QUESTION_TYPE.CHECKBOX_CARD,
      "name": RISK_STEP_LABEL,
      "question_text": "Risiko der Aussetzung der Anteilsrücknahme",
      "custom_classes": {"label": "regular"},
      "size": 6
    },
    {
      "uid": "risk_currency",
      "type": QUESTION_TYPE.CHECKBOX_CARD,
      "name": RISK_STEP_LABEL,
      "question_text": "Währungsrisiko",
      "custom_classes": {"label": "regular"},
      "size": 6,
    },
    {
      "uid": "risk_interest_rate",
      "type": QUESTION_TYPE.CHECKBOX_CARD,
      "name": RISK_STEP_LABEL,
      "question_text": "Zinsänderungsrisiko",
      "custom_classes": {"label": "regular"},
      "size": 6,
    },
    {
      "uid": "risk_additional",
      "type": QUESTION_TYPE.CHECKBOX_CARD,
      "name": RISK_STEP_LABEL,
      "question_text": "Weitere Risiken",
      "custom_classes": {"label": "regular"},
      "size": 6,
    },
    {
      "uid": "risk_additional_details",
      "type": "input",
      "name": "Weitere Risiken",
      "config": {
        "multiline": true,
        "placeholder": "Bitte schreiben Sie hier"
      },
      "validateImmediately": true,
      "isValid": function(step, afterChange) {
        let isValid = true
        // validate required ONLY on button click

        if(!afterChange && isRequiredQuestion(this)) {
          isValid = !!this.answer;
          this.error = isValid ? null : FIELD_REQUIRED_MSG;
        } else if (this.answer) {
          isValid = validateMultilineContent(this.answer, 340)
          this.error = isValid ? null : FIELD_DOES_NOT_FITT_MSG
        }

        return isValid
      }
    }
  ]
};

const step3 = {
  "uid": "finalize-client",
  "name": "Sind die Kundenangaben aktuell? *",
  "behaviour": ["dynamic"],
  "category": "Kundenangabe",
  "step_content": ClientStepV2,
  "question": [
    {
      "uid": "data_type",
      "type": "normal",
      "behaviour": [QUESTION_TYPE.RADIO_CARDS],
      "optional": false,
      "question_text": '',
      "config": {
        "choices": [
          {
            "id": 1,
            "uid": "1",
            "text": "<option_1_text> <data_type_date>",
          },
          {
            "id": 2,
            "uid": "2",
            "text": "<option_2_text>"
          }
        ]
      },
      "isValid": function (){
        const isValid = !!this.answer;
        this.error = isValid ? null : FIELD_REQUIRED_MSG;
        return isValid;
      },
      "custom_classes": {
        formControlLabelLabel: 'MuiGrid-container MuiGrid-wrap-xs-nowrap',
      }
    }, {
      "uid": "data_type_date",
      "type": "date",
      "custom_classes": newDesignInputCustomClasses,
      "isValid": function (step=undefined) {
        if (step) {
          if (step.question[0].answer == 1) {
            const isValid = !!this.answer;
            this.error = isValid ? null : FIELD_REQUIRED_MSG;
            return isValid;
          }
        }
        return true
      }
    }
  ]
};

const CONVERSATION_DETAILS_GROUP = 'Angaben zum Gespräch';
const DOCUMENTS_GROUP = 'Dokumente';
const INTERVIEW_CUSTOMER_INPUT_UID = "interview_customer_input";
export const INTERVIEW_PLACE_CUSTOMER_INPUT_UID = "interview_place_customer_input";
export const ACCOUNT_HOLDER_1_UID = buildQuestionUIDForMember(INTERVIEW_CUSTOMER_INPUT_UID, 0);
export const ACCOUNT_HOLDER_2_UID = buildQuestionUIDForMember(INTERVIEW_CUSTOMER_INPUT_UID, 1);
export const INTERVIEW_PLACE_ACCOUNT_HOLDER_1_UID = buildQuestionUIDForMember(
  INTERVIEW_PLACE_CUSTOMER_INPUT_UID, 0);
export const INTERVIEW_PLACE_ACCOUNT_HOLDER_2_UID = buildQuestionUIDForMember(
  INTERVIEW_PLACE_CUSTOMER_INPUT_UID, 1);

export const INTERVIEW_PLACE = {
  ONLINE: 1,
  BROKER: 2,
  CUSTOMER: 3,
  OTHER: 4
};

const timeClasses = {...newDesignInputCustomClasses, textFieldRoot: 'w-100'};

const dateAndPlaceStep = {
  "uid": "finalize-conversation-details-date-place",
  "name": "Wann fand das Gespräch statt?",
  "parent": CONVERSATION_DETAILS_GROUP,
  "behaviour": ["dynamic"],
  "category": "Datum & Ort",
  "step_content": DateAndPlaceStep,
  "question": [
    {
      "uid": "interview_date",
      "question_text": "Gesprächsdatum",
      "type": "date",
      "optional": true,
      "required_check": true,
      "custom_classes": newDesignInputCustomClasses,
      "disableDatesCallback": function(){
        return false; // all dates available
      }
    },
    {
      "uid": "interview_start_time",
      "question_text": "Gesprächsbeginn",
      "type": "time",
      "optional": true,
      "required_check": true,
      "custom_classes": timeClasses,
      "placeholder": "Von",
    },
    {
      "uid": "interview_end_time",
      "question_text": "Gesprächsende",
      "optional": true,
      "required_check": true,
      "type": "time",
      "placeholder": "Bis",
      "custom_classes": timeClasses,
      "isValid": function (step) {
        if (step) {
          if (step.question[1].answer && this.answer) {
            const isValid = moment(step.question[1].answer) < moment(this.answer);
            this.error = isValid ? null : 'Sollte nach der "' + step.question[1].question_text + '" sein';
            return isValid;
          }
        }
        const isValid = !!this.answer;
        this.error = isValid ? null : FIELD_REQUIRED_MSG;
        return isValid
      }
    },
    {
      "uid": "interview_place",
      "question_text": "Wo fand das Gespräch statt?",
      "type": "normal",
      "behaviour": [QUESTION_TYPE.RADIO_CARDS],
      custom_classes: {
        radioGroupRoot: 'MuiGrid-container',
        formControlLabelRoot: 'MuiGrid-item',
        labelRoot: 'asCategory',
        formControlLabelLabel: 'MuiGrid-container MuiGrid-justify-xs-space-between',
      },
      "config": {
        "choices": [
          {
            "id": INTERVIEW_PLACE.ONLINE,
            "uid": INTERVIEW_PLACE.ONLINE.toString(),
            "text": "Telefonisch bzw. Internet/Videoanruf",
            "info_text": "Haben Sie das Gespräch aufgezeichnet?",
            "infoIconColor": GREY_INFO_COLOR,
          },
          {
            "id": INTERVIEW_PLACE.BROKER,
            "uid": INTERVIEW_PLACE.BROKER.toString(),
            "text": "Firmensitz / beim Berater",
          },
          {
            "id": INTERVIEW_PLACE.CUSTOMER,
            "uid": INTERVIEW_PLACE.CUSTOMER.toString(),
            "text": "Beim Kunden",
          },
          {
            "id": INTERVIEW_PLACE.OTHER,
            "uid": INTERVIEW_PLACE.OTHER.toString(),
            "text": "Sonstiger Ort",
          },
        ]
      },
      "optional": true,
      "required_check": true,
    },
    {
      "uid": "interview_place_broker_input",
      "question_text": "Ort des Vermittlers",
      "type": "input",
      "optional": true,
      "required_check": true,
      "custom_classes": newDesignInputCustomClasses,
    },
    {
      "uid": INTERVIEW_PLACE_CUSTOMER_INPUT_UID,
      "question_text": "Ort des Kunden",
      "type": "input",
      "custom_classes": newDesignInputCustomClasses,
    },
    {
      "uid": INTERVIEW_PLACE_ACCOUNT_HOLDER_1_UID,
      "question_text": "Ort des Kunden 1",
      "type": "input",
      "_ignore": true,
      "custom_classes": newDesignInputCustomClasses,
    },
    {
      "uid": INTERVIEW_PLACE_ACCOUNT_HOLDER_2_UID,
      "question_text": "Ort des Kunden 2",
      "type": "input",
      "_ignore": true,
      "custom_classes": newDesignInputCustomClasses,
    },
  ]
};

const participantsStep = {
  "uid": "finalize-conversation-details-participants",
  "name": "Wer hat an dem Gespräch teilgenommen?",
  "behaviour": ["dynamic"],
  "category": "Gesprächsteilnehmer",
  "parent": CONVERSATION_DETAILS_GROUP,
  "step_content": ParticipantsStep,
  "question": [
    {
      "uid": "interview_broker_input",
      "question_text": "Vermittler/-in",
      "type": "input",
      "optional": true,
      "required_check": true,
      "custom_classes": newDesignInputCustomClasses,
    },
    {
      "uid": INTERVIEW_CUSTOMER_INPUT_UID,
      "question_text": "Kunde/-in",
      "type": "input",
      "custom_classes": newDesignInputCustomClasses,
    },
    {
      "uid": ACCOUNT_HOLDER_1_UID,
      "question_text": "Kunde/-in 1",
      "type": "input",
      "_ignore": true,
      "custom_classes": newDesignInputCustomClasses,
    },
    {
      "uid": ACCOUNT_HOLDER_2_UID,
      "question_text": "Kunde/-in 2",
      "type": "input",
      "_ignore": true,
      "custom_classes": newDesignInputCustomClasses,
    },
    {
      "uid": "interview_other_peoples_input",
      "type": "input",
      "question_text": "Weitere Gesprächsteilnehmer",
      "validateImmediately": true,
      "isValid": function(step, afterChange) {
        let isValid = true;

        if (this.answer) {
          isValid = validateMultilineContent(this.answer, 28, false)
          this.error = isValid ? null : FIELD_DOES_NOT_FITT_MSG
        }

        return isValid
      },
      "custom_classes": newDesignInputCustomClasses,
    },
    {
      "uid": "interview_date_type",
      "type": "normal",
      "question_text": "Es handelt sich um",
      "behaviour": [QUESTION_TYPE.RADIO_CARDS],
      "config": {
        "choices": [
          {
            "id": 1,
            "uid": "1",
            "text": "Das Erstgespräch",
          },
          {
            "id": 2,
            "uid": INTERVIEW_TYPE_CONTINUE_OPTION_VALUE,
            "text": "Einen Folgetermin"
          }
        ]
      },
      "optional": true,
      "required_check": true,
      "custom_classes": {
        labelRoot: 'asCategory',
      }
    },
    {
      "uid": "interview_repeated_date",
      "type": "date",
      "question_text": "Folgetermin zum Gespräch vom",
      "disableDatesCallback": function(){
        return false; // all dates available
      },
      "isValid": function (step=undefined) {

        if (step) {
          if (step.question.find(q => q.uid === 'interview_date_type').answer == 2) {
            const isValid = !!this.answer;
            this.error = isValid ? null : FIELD_REQUIRED_MSG;
            return isValid;
          }
        }

        return true
      },
      "custom_classes": newDesignInputCustomClasses,
    }
  ]
};

const sustainabilityStep = {
  "uid": "finalize-sustainability-check",
  "name": "Wird mit dem Kunden/der Kundin eine dauerhafte Geeignetheitserklärung vereinbart? *",
  "behaviour": ["dynamic"],
  "category": "Geeignetheitsprüfung",
  "parent": CONVERSATION_DETAILS_GROUP,
  "question": [
    {
      "uid": "permanent_suitability_check",
      "size": 6,
      "optional": false,
      "type": "normal",
      "behaviour": [QUESTION_TYPE.RADIO_CARDS],
      "custom_classes": {
        "labelRoot": "bold",
      },
      "config": {
        "choices": [
          {
            "id": 1,
            "uid": radioYesUID,
            "text": <><b>Ja</b>, eine dauerhafte Geeignetheitsprüfung wird vereinbart.</>
          },
          {
            "id": 2,
            "uid": radioNoUID,
            "text": <><b>Nein</b>, es wird keine dauerhafte Geeignetheitsprüfung vereinbart.</>
          }
        ]
      },
    }
  ]
};

const initiatorStep = {
  "uid": "finalize-conversation-details-initiator",
  "name": "Von wem ging die Gesprächsinitiative aus? *",
  "behaviour": ["dynamic"],
  "category": "Gesprächsinitiative",
  "parent": CONVERSATION_DETAILS_GROUP,
  "question": [
    {
      "uid": "interview_initiative",
      // "question_text": "Gesprächsinitiative",
      "type": "text",
      "optional": false,
      "custom_classes": {
        "labelRoot": "bold",
      },
    },
  ]
};

const reasonStep = {
  "uid": "finalize-conversation-details-reason",
  "name": "Individuelle Begründung der Anlageentscheidung",
  "behaviour": ["dynamic"],
  "category": "Begründung",
  "parent": CONVERSATION_DETAILS_GROUP,
  "question": [
    {
      "uid": "interview_reasons",
      // "question_text": "Individuelle Begründung der Anlageentscheidung",
      "type": "text",
      "optional": true,
      "custom_classes": {
        "labelRoot": "bold",
      },
    },
  ]
};

const documentsDelivery = {
  "uid": "finalize-documents-delivery",
  "name": "Wir werden das Protokoll und die zugehörigen Anlagen inkl. Ex-ante Kostenausweis zugestellt? *",
  "behaviour": ["dynamic"],
  "category": "Zustellung",
  "parent": DOCUMENTS_GROUP,
  "step_content": WaysOfDistributionStep,
  "question": [
    {
      "uid": "ways_of_distribution",
      "className": "align-center",
      "question": [
        {
          "uid": "ways_of_distribution['electronically']",
          "type": QUESTION_TYPE.CHECKBOX_CARD,
          "question_text": "Die Dokumente werden auf einem dauerhaften Datenträger elektronisch übermittelt (PDF / E-Mail)",
          "custom_classes": {"label": "regular"},
          "size": 7,
        }, {
          "uid": "ways_of_distribution['end_of_consultation']",
          "type": QUESTION_TYPE.CHECKBOX_CARD,
          "question_text": "Die Dokumente werden am Ende der Beratung übergeben",
          "custom_classes": {"label": "regular"},
          "size": 7,
        }, {
          "uid": "ways_of_distribution['by_post']",
          "type": QUESTION_TYPE.CHECKBOX_CARD,
          "question_text": "Die Dokumente werden per Post zugesandt",
          "custom_classes": {"label": "regular"},
          "size": 7,
        }
      ],
      "isValid": function(){
        if (!this.optional) {
          const isValid = this.question.some(q => q.answer);
          this.error = isValid ? null : FIELD_REQUIRED_MSG;
          return isValid;
        }
        return true
      }
    }
  ]
};

const step6 = {
  "uid": "finalize-documents-downloading",
  "initStepAsync": initDocumentsStep,  // provider fetches documents + computes defaults before render
  "loading_msg": 'Bitte warten Sie einen Moment. Ihre ausgewählten Dokumente werden erzeugt.',
  "name": "Auswahl der Dokumente",
  "parent": DOCUMENTS_GROUP,
  "behaviour": ["dynamic"],
  "category": "Auswahl der Dokumente",
  "step_content": DocumentsDownload,
  "question": [
    {
      "uid": "documents",
      "type": "input",
      "isValid": function () {

        const documentsToDownload = _.get(this.answer || {}, 'download') || []
        const documentsToSign = _.get(this.answer || {}, 'eSign') || []

        this.errors = null
        const errors = {}

        Object.entries(this.documents || {}).forEach(([object_type, depots]) => {
          Object.keys(depots).forEach((depot_id) => {
            this.documents[object_type][depot_id].documentsToValidate.forEach((document) => {

              const isDocumentSelected = _.get(documentsToDownload, `${object_type}.${depot_id}`, []).includes(document.id) || _.get(documentsToSign, `${object_type}.${depot_id}`, []).includes(document.id)
              if (document.is_mandatory && !isDocumentSelected) {

                if (!errors.hasOwnProperty(object_type)) {
                  errors[object_type] = {}
                }

                if (!errors[object_type].hasOwnProperty(depot_id)) {
                  errors[object_type][depot_id] = {}
                }

                errors[object_type][depot_id][document.id] = 'Dokument ist obligatorisch'
              }

            })
          })

        })

        if (!_.isEmpty(errors)) {
          this.errors = errors
          return false
        }

        return true
      }
    }
  ]
};

const congratsStep = {
  "uid": CONGRATS_STEP_ID,
  "name": "Aufklärung & Protokoll",
  "successBody": "Die Kundendaten wurde erfolgreich gespeichert. Fahren Sie fort mit Aufklärung & Protokoll um den prozess erfolgreich abschließen zu können.",
  "behaviour": ["congrats"]
};


export const protocolStepsData = {
  steps: [
    finilizeSellsStep,
    conflictsStep,
    step2,
    step3,
    dateAndPlaceStep,
    participantsStep,
    sustainabilityStep,
    initiatorStep,
    reasonStep,
    documentsDelivery,
    step6,
    congratsStep
  ],
};